<template>
  <div>
    <!-- 工具栏 -->
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>
      </div>
    </div>

    <el-table ref="tableRef" v-loading="loading" :data="tableData" border stripe class="data-table"
              :header-cell-style="{ background: '#F5F7FA' }">
      <el-table-column label="#" prop="forumGroupFileId" align="center"></el-table-column>
      <el-table-column label="文件名" prop="fileShowName" align="center"></el-table-column>
      <el-table-column label="源文件名" prop="fileName" align="center"></el-table-column>
      <el-table-column label="上传者" prop="uploadInfo" align="center" show-overflow-tooltip>
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column label="上传时间" prop="createTime" align="center">
        <template #default="scope">
          {{ scope.row.createTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button type="primary" size="small" @click="previewFile(scope.row)">预览</el-button>
          <el-button type="primary" size="small" @click="downloadFile(scope.row)">下载</el-button>
          <el-button :type="scope.row.isDeleted ? 'warning' : 'danger'" size="small"
                     @click="handleDeleteOrBackFile(scope.row)">
            {{ scope.row.isDeleted ? '恢复' : '删除' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :total="pageOpt.totalCount" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.currentPage" @current-change="curPageChange"/>


    <!--对话框：浏览PDF文件-->
    <el-dialog
        :visible.sync="previewFileDlg"
        :destroy-on-close='true'
        width="80%"
        center>
      <div width="60%">


        <div v-if="previewFileType === 'pdf'" class="dialog-body-content-base-style"
             style="justify-content: center; align-items: center;color: red">
          <embed :src="this.previewFileUrl" style="width: 100%; height: 700px"/>
        </div>
        <div v-else-if="previewFileType === 'txt'" class="dialog-body-content-base-style"
             style="justify-content: center; align-items: center;color: red;">
          <el-input :autosize="{ minRows: 2, maxRows: 25 }" type="textarea" disabled="true" placeholder=""
                    v-model="previewTextContent">
          </el-input>
        </div>
        <div v-else-if="previewFileType === 'doc'" class="dialog-body-content-base-style"
             style="justify-content: center; align-items: center;" height="60%">
          <iframe frameborder="0"
                  :src="'https://view.officeapps.live.com/op/view.aspx?src=' + this.previewFileUrl"
                  style="width: 100%;height: 60vh;overflow: auto;">
          </iframe>
        </div>
        <div align="center" v-else-if="previewFileType === 'img'" :height="boxHeight" :width="boxWidth">
          <img class="" lazy :src="previewFileUrl" fit="scale-down" @load="onLoadImg"
               :preview-src-list="[previewFileUrl]" :height="boxHeight" :width="boxWidth"/>
        </div>
        <div v-else-if="previewFileType === 'video'" align="center" class="dialog-body-content-base-style"
             style="justify-content: center; align-items: center">
          <!--          <video :src="this.previewFileUrl" controls autoplay class="video" width="100%"></video>-->
          <tx-video-player style="height: 60vh" :video-url="previewFileUrl"></tx-video-player>
        </div>
        <div v-else-if="previewFileType === 'audio'" align="center" class="dialog-body-content-base-style">
          <audio :src="this.previewFileUrl" autoplay="autoplay" controls="controls" ref="audio"
                 style="width: 70%"></audio>
        </div>
        <div v-else>
          <p align="center">当前格式不支持预览</p>
        </div>
        <div align="center" style="margin-top: 10px;font-weight: bold">{{ this.previewFileUrl }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getForumGroupFileList,
  forumGroupFileDeleteOrBack
} from "@/api/ultrasonicGroupsDetail";
import {handleRes} from "@/utils/handleRes";
import {getCloudUrl} from "@/utils/urlutil";
import {getDisplayName} from "@/utils/userutil";
import {downloadFile} from "@/utils/OSSUpload";
import txVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import UserInfo from "@/components/UserInfo/UserInfo";

export default {
  name: "ultrasonicGroupFiles",
  components: {UserInfo, TxVideoPlayer},
  props: {
    ForumGroupID: {
      Number
    }
  },
  data() {
    return {
      loading: false, // 加载开关
      tableData: [], // 传值给子组件mytable
      // 分页配置
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      searchValue: "",

      previewFileUrl: "",
      previewFileDlg: false,
      previewFileType: "",
      boxHeight: "",
      boxWidth: "",
      previewTextContent: ""
    }
  },
  created() {
    this.getForumGroupFileList()
  },
  methods: {
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    getName(entity) {
      return getDisplayName(entity)
    },
    search() {
      this.refreshList()
    },
    refreshList() {
      this.pageOpt.currentPage = 1
      this.getForumGroupFileList()
    },
    curPageChange(curPage) {
      this.pageOpt.currentPage = curPage
      this.getForumGroupFileList()
    },
    getForumGroupFileList() {
      let para = {
        forumGroupId: this.ForumGroupID,
        sortName: "",
        sortOrder: "",
        pageNumber: this.pageOpt.currentPage,
        pageSize: this.pageOpt.pageSize,
        keyWord: this.searchValue,
      }
      getForumGroupFileList(para).then(res => {
        handleRes(res, () => {
          this.pageOpt.totalCount = res.data.total
          this.tableData = res.data.rows
        })
      })
    },
    handleDeleteOrBackFile(entity) {
      forumGroupFileDeleteOrBack({
        forumGroupFileId: entity.forumGroupFileId
      }).then(res => {
        handleRes(res, () => {
          this.getForumGroupFileList()
        })
      })
    },
    previewFile(entity) {
      this.previewFileUrl = getCloudUrl(entity.downUrl)
      // this.previewFileUrl = getCloudUrl("/UploadFiles/DocumentFiles/1972936/1656037923572_1656037971536")
      var suffix = entity.fileSuffix.toLowerCase()
      suffix = suffix.indexOf(".") >= 0 ? suffix : `.${suffix}`
      // this.previewFileUrl = getCloudUrl("/UploadFiles/DocumentFiles/1083751/1655983218623_1655983277422")
      // suffix = '.pdf'
      if (suffix === '.pdf') {
        this.previewFileType = 'pdf'
      } else if (suffix === '.txt') {
        this.previewFileType = 'txt'
        this.urlToBlob();
      } else if (suffix === '.png' || suffix === '.jpg') {
        this.previewFileType = 'img'
      } else if (suffix === '.mp3') {
        this.previewFileType = 'audio'
      } else if (suffix === '.mp4') {
        this.previewFileType = 'video'
      } else if (suffix === ".doc" || suffix === ".docx" || suffix === ".xls" || suffix === ".xlsx" || suffix === '.csv') {
        this.previewFileType = 'doc'
      } else {
        this.previewFileType = 'other'
      }
      console.log(`------  ${entity.fileSuffix} ${this.previewFileType} ${this.previewFileUrl}`)
      this.previewFileDlg = true
    },
    urlToBlob() {
      let file_url = this.previewFileUrl
//可以是具体.txt也可以是接口返回的blob，或者web转换
      let xhr = new XMLHttpRequest();
      xhr.open("get", file_url, true);
      xhr.responseType = "blob";
      let self = this//onload this指向为window中转一下
      xhr.onload = function () {
        if (this.status == 200) {
          console.log(this.response)
          const reader = new FileReader()
          reader.onload = function () {
            self.previewTextContent = reader.result//获取的数据data
            console.log('reader.result', reader.result)
          }
          reader.readAsText(this.response);
        }
      };
      xhr.send();
    },
    downloadFile(entity) {
      downloadFile(getCloudUrl(entity.downUrl))
    },
    onLoadImg: function (e) {
      const imgURL = this.previewFileUrl;
      const res = new Image();
      res.src = imgURL;
      if (res.naturalHeight / res.naturalWidth > 1) {
        this.boxHeight = 650 + 'px';
        this.boxWidth = Math.floor(650 * res.naturalWidth / res.naturalHeight) + 'px';
      } else if (res.naturalHeight / res.naturalWidth === 1) {
        if (res.naturalHeight > 650) {
          this.boxHeight = 650 + 'px';
          this.boxWidth = 650 + 'px';
        } else {
          this.boxWidth = res.naturalWidth + 'px';
          this.boxHeight = res.naturalHeight + 'px';
        }
      } else if (res.naturalWidth / res.naturalHeight > 1) {
        this.boxWidth = 900 + 'px';
        this.boxHeight = Math.floor(900 * res.naturalHeight / res.naturalWidth) + 'px';
      }
      this.$forceUpdate();
    },
  }
}
</script>

<style scoped>

/*img {*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  max-width: 900px;*/
/*  max-height: 550px;*/
/*  object-fit: scale-down;*/
/*  border: 1px dashed #ccc;*/
/*}*/

</style>